<template>
  <div class="device-error-bg">
    <!-- <i class="fas fa-exclamation-triangle"></i> -->
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="error-template">
            <h1 style="margin-top:20px">
              <i class="fas fa-exclamation-triangle"></i>
              Device Error
            </h1>
            <!-- <h2>Not Found</h2> -->
            <br />
            <div class="error-details">
              Sorry, you have used another device to log in to APEX.
              <br />Please log out from the device.
              <!-- <br />Requested page not found! -->
            </div>
            <br />
            <!-- <div @click="getInfo" class="error-actions">
              <i style="font-size:80px; color:#FFF" class="fas fa-sync"></i>
              <br />
              <b style="color:#FFF">Refresh</b>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import TopNav from "@/components/TopNav/TopNav.vue";
export default {
  name: "Error",
  // components: {
  //   TopNav: TopNav
  // },
  methods: {
    back: function() {
      this.$router.go(-1);
    }
  },
  mounted: function() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function() {
      history.pushState(null, null, document.URL);
    });
  }
};
</script>
<style lang="scss" scoped>
.device-error-bg {
  background: rgb(32, 201, 151);
  position: fixed;
  height: 100%;
  width: 100%;
}
.error-details {
  // text-align: left;
  font-size: 1.3rem;
  padding: 1rem;
}
</style>
